var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-danger",class:{ 'ml-1': _vm.$dir.ltr, 'mr-1': _vm.$dir.rtl }},[_vm._v("\n  *\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }